// extracted by mini-css-extract-plugin
module.exports = {"upDownButton":"up_down_button_style_upDownButton__3dpHy","upButton":"up_down_button_style_upButton__1mES6","downButton":"up_down_button_style_downButton__HUnqK"};